import moment from 'moment';

import { showNotification } from 'actions/notification';

export const notify = (dispatch, text) =>
  dispatch(showNotification({ text, duration: 5, showCloseIcon: true }));

export const cellKey = (region, gradeRange, tier) => `${region}|${gradeRange}|${tier}`;

export const fmtDate = d => (d ? moment(d).format('DD MMM YYYY') : null);

// Half-open window [validity_start, validity_end): active when start <= today < end.
// A null validity_end is open-ended (+infinity) and never bounds the window from above
// — matching windowsOverlap. moment(null) is Invalid, so guard it explicitly.
export const isActiveToday = row => {
  const today = moment().startOf('day');
  const start = moment(row.validity_start);
  const end = row.validity_end ? moment(row.validity_end) : null;
  return start.isSameOrBefore(today) && (!end || end.isAfter(today));
};

// When a key has several windows (only possible in "all" mode), show the one active
// today; otherwise the one starting latest.
export const preferWindow = (a, b) => {
  const aActive = isActiveToday(a);
  const bActive = isActiveToday(b);
  if (aActive !== bActive) return aActive ? a : b;
  return moment(b.validity_start).isAfter(moment(a.validity_start)) ? b : a;
};

// Do half-open windows [ns, ne) and [es, ee) overlap? A null end means open-ended
// (+infinity). Abutting windows ([a,b) and [b,c)) do NOT overlap.
export const windowsOverlap = (ns, ne, es, ee) => {
  const newStart = moment(ns);
  const newEnd = ne ? moment(ne) : null;
  const exStart = moment(es);
  const exEnd = ee ? moment(ee) : null;
  const startsBeforeExEnd = !exEnd || newStart.isBefore(exEnd);
  const endsAfterExStart = !newEnd || newEnd.isAfter(exStart);
  return startsBeforeExEnd && endsAfterExStart;
};

// Order a derived set of values by a reference list (known values first, in
// reference order), with any values not in the reference appended alphabetically.
export const orderByReference = (values, reference) => {
  const refIndex = new Map(reference.map((v, i) => [v, i]));
  return Array.from(values).sort((a, b) => {
    const ia = refIndex.has(a) ? refIndex.get(a) : Infinity;
    const ib = refIndex.has(b) ? refIndex.get(b) : Infinity;
    if (ia !== ib) return ia - ib;
    return a < b ? -1 : a > b ? 1 : 0;
  });
};

// Effective amount for a bulk cell: the user's override if they typed one, otherwise
// the current rate prefilled as the starting point. `current == null` means empty cell.
export const bulkCellValue = (bulkValues, key, current) => {
  if (Object.prototype.hasOwnProperty.call(bulkValues, key)) return bulkValues[key];
  return current == null ? '' : String(current);
};
